module.exports = __webpack_public_path__ + "img/usd.bc90ea65.png";